import { useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { getIdentifyStatus, loadIdentify } from "../../store/identify";

const IdentityLoader = ({ children }) => {
  const dispatch = useDispatch();

  const identifyStatus = useSelector(getIdentifyStatus);

  useEffect(() => {
    dispatch(loadIdentify());
  }, []);

  if (identifyStatus)
    return (
      <svg className="animate-spin h-5 w-5 mr-3 bg-black" viewBox="0 0 24 24">
        0000
      </svg>
    );
  return children;
};

IdentityLoader.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};

export default IdentityLoader;
